import React from "react";
import "./pokeball.css";

function Pokeball() {
  return(
  <div className="pokeBody">
    <div className="pokeContain">
      <div className="mainBall">
        <div className="pokeButton">
          
        </div>
      </div>
    </div>
  </div>
  );
};

export default Pokeball;
